module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/medal-01-1d90f04d6a7667e8e245d5bc555f60de.png";